module.exports = __webpack_public_path__ + "img/hyh.68f3b244.svg";